import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { TrackingHOC } from 'hocs'
import { browserHistory } from 'react-router'
import InlineLoader from 'components/InlineLoader'
import Tutorial from 'components/Tutorial'
import {
  selectCurrentTutorialId,
  selectTutorials,
  selectCurrentPhoneTutorialId,
  selectCurrentTutorial,
  structuredTutorialState,
  selectCurrentStep
} from './selectors'
import {
  fetchTutorialList,
  fetchTutorialSteps,
  updateStep,
  playStepAnimation,
  playAllStepAnimation
} from './actions'
import { selectCurrentPhoneId, selectLanguage } from '../App/selectors'
import { updateTitle } from '../Breadcrumbs/actions'
import { addRecent } from '../RecentTopics/actions'
import { getCustomer } from 'helpers'

class TutorialsContainer extends Component {
  static contextTypes = { router: PropTypes.object.isRequired }

  constructor(props) {
    super(props)
    this.state = { relatedData: [], isFetching: true, width: 0, height: 0 }

    this.updateDimensions = this.updateDimensions.bind(this)
  }

  componentDidMount() {
    const { updateCurrentTutorial, fetchTutorialList, routeParams } = this.props
    const currentPhoneId = this.props.location.query.device

    fetchTutorialList(currentPhoneId)
    updateCurrentTutorial(parseInt(routeParams.id, 10))

    window.addEventListener('resize', this.updateDimensions)
  }

  UNSAFE_componentWillMount() {
    this.updateDimensions()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions() {
    let w = window,
      d = document,
      documentElement = d.documentElement,
      body = d.getElementsByTagName('body')[0],
      width = w.innerWidth || documentElement.clientWidth || body.clientWidth,
      height =
        w.innerHeight || documentElement.clientHeight || body.clientHeight

    this.setState({ width, height })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      updateCurrentTutorial,
      tutorials,
      currentPhoneId,
      routeParams,
      fetchTutorialList
    } = this.props

    if (
      nextProps.currentPhoneId === null &&
      nextProps.currentPhoneId !== currentPhoneId
    ) {
      browserHistory.push('/')
    }

    if (tutorials.length > 0 && routeParams.id !== nextProps.routeParams.id) {
      fetchTutorialList(nextProps.location.query.device)
      updateCurrentTutorial(parseInt(nextProps.routeParams.id, 10))
    }

    if (
      nextProps.currentTutorial[0] &&
      this.props.currentTutorial !== nextProps.currentTutorial
    ) {
      this.props.updateTitle(nextProps.currentTutorial[0].tutorial.name)

      this.props.addRecent({
        contentType: 'tutorial',
        contentId: nextProps.tutorialState.tutorial.id,
        deviceId: nextProps.location.query.device,
        contentTitle: nextProps.currentTutorial[0].tutorial.name,
        customer: getCustomer()
      })

      this.props.createEvent({
        category: 'tutorials',
        data: {
          action: 'View',
          target: nextProps.tutorialState.tutorial.id
        }
      })
    }
  }

  render() {
    const {
      createEvent,
      currentTutorial,
      updateStep,
      language,
      playStepAnimation,
      tutorialState,
      playAllStepAnimation
    } = this.props

    if (currentTutorial.length === 0 || tutorialState.tutorial.type === 0) {
      return <InlineLoader style={{ margin: '0 auto', display: 'block' }} />
    }

    return (
      <Tutorial
        createUserEvent={createEvent}
        updateStep={updateStep}
        language={language}
        data={tutorialState.tutorial}
        dropdownCount={Math.max(
          tutorialState.infoBar.categories.length,
          tutorialState.infoBar.categoryTutorials.length
        )}
        playStepAnimation={playStepAnimation}
        playAllStepAnimation={playAllStepAnimation}
        windowDimensions={{
          width: this.state.width,
          height: this.state.height
        }}
        currentPhoneId={this.props.location.query.device}
        currentTutorial={currentTutorial}
        id={this.props.params.id}
        currentStep={this.props.currentStep}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  currentPhoneId: selectCurrentPhoneId(state),
  currentPhoneTutorialId: selectCurrentPhoneTutorialId(state),
  currentTutorial: selectCurrentTutorial(state),
  language: selectLanguage(state),
  query: state.routing.locationBeforeTransitions.query,
  currentTutorialId: selectCurrentTutorialId(state),
  tutorials: selectTutorials(state),
  tutorialState: structuredTutorialState(state),
  currentStep: selectCurrentStep(state)
})

const mapDispatchToProps = (dispatch) => ({
  fetchTutorialList: (currentPhoneId) =>
    dispatch(fetchTutorialList.request(currentPhoneId)),
  updateCurrentTutorial: (tutorialId) =>
    dispatch(fetchTutorialSteps.request(tutorialId)),
  updateStep: (step) => dispatch(updateStep(step)),
  playStepAnimation: () => dispatch(playStepAnimation()),
  playAllStepAnimation: () => dispatch(playAllStepAnimation()),
  updateTitle: (title) => dispatch(updateTitle(title)),
  addRecent: (topic) => dispatch(addRecent(topic))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrackingHOC(TutorialsContainer))
